(function () {
	'use strict';

	a3_pilot_reports.controller('PaxCtrl', PaxCtrl);

	/**
	* @memberof PilotReports
	* @ngdoc controller
	* @name PaxCtrl
	* @description 
	*  Manages the passenger seatmap and information view
	* @ngInject
	*/
	function PaxCtrl($scope, FlightFactory, PaxInfoFactory, $routeParams, $uibModal, $location) {
		var flightId = $routeParams.flightId;
		var flight = FlightFactory.getFlightFromStorage(flightId);
		var paxInfo = PaxInfoFactory.getPaxInfoFromStorage(flightId);

		$scope.state = 'pax';
		$scope.flight = flight;
		$scope.showMobileMenuFilters = false;
		$scope.filterPax = filterPax;
		$scope.viewMode = viewMode;
		$scope.filterRow = filterRow;
		$scope.filterCol = filterCol;
		$scope.paxInfo = paxInfo;
		$scope.howClose = '';
		$scope.IsOld = IsOld;
		$scope.openPassenger = openPassenger;
		$scope.resetFilters = resetFilters;
		$scope.isConnectedFlightClose = isConnectedFlightClose;
		$scope.TimeDifference = TimeDifference;
		$scope.IsProvisional = true;
		$scope.specialMeals = 0;
		$scope.toggleFlightInfoView = toggleFlightInfoView;
		$scope.mode = "seatMap";
		$scope.radioModel = "Seatmap";

		if (flight == null) {
			flight = FlightFactory.getLocalFlightFromStorage(flightId)
		}

		if (flight != null) {
			if (paxInfo) {
				var connectingPax = 0;
				for (var i = 0; i < paxInfo.ConnectingFlights.length; i++) {
					connectingPax = connectingPax + paxInfo.ConnectingFlights[i].PassengerSummaryC.Passengers
						+ paxInfo.ConnectingFlights[i].PassengerSummaryY.Passengers;
				}
				$scope.connectingPax = connectingPax;

				for (var i = 0; i < paxInfo.Seatmap.length; i++) {
					for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {

						if (paxInfo.Seatmap[i].Columns[j].SpecialMeal) {
							$scope.specialMeals++;
						}

						if (paxInfo.Seatmap[i].Columns[j].SpecialMealB) {
							$scope.specialMeals++;
						}


						if (paxInfo.Seatmap[i].Columns[j].ConnectingFlightId && paxInfo.Seatmap[i].Columns[j].ConnectingFlightId != 0) {

							for (var h = 0; h < paxInfo.ConnectingFlights.length; h++) {
								if (paxInfo.Seatmap[i].Columns[j].ConnectingFlightId == paxInfo.ConnectingFlights[h].FlightId) {
									paxInfo.Seatmap[i].Columns[j].Connection = paxInfo.ConnectingFlights[h];
								}
							}
						}
					}
				}

				var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
				var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime();
				//20 minutes before takeoff
				if (DepartureTimestamp - listSentTimestamp <= 1200000) {
					$scope.IsProvisional = false;
				}
			}

			var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
			$scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;

			initializeFilters();
			initializeViewMode();
		} else {
			$location.path("/");
		}

		/**
		 * Initialize Passenger Filters
		 * @memberof PaxCtrl
		 */
		function initializeFilters() {
			$scope.filterPaxC = false;
			$scope.filterPaxY = false;
			$scope.filterAdults = false;
			$scope.filterChildren = false;
			$scope.filterInfants = false;
			$scope.filterUMs = false;
			$scope.filterFqtv = false;
			$scope.filterConnections = false;
			$scope.filterSpecialMeals = false;
			$scope.filterFqtvSilver = false;
			$scope.filterFqtvGold = false;
			$scope.filterWheelchair = false;
			$scope.filterAssistance = false;
			$scope.filterDeportees = false;
			$scope.filterDHC = false;
			$scope.filterVIP = false;
		}

		/**
		 * Filter Passenger by given filter
		 * @memberof PaxCtrl
		 * @param {string} criteria The selected filter criteria
		 */
		function filterPax(criteria) {
			if (criteria == "PaxC") {
				var val = !$scope.filterPaxC;
				initializeFilters();
				$scope.filterPaxC = val;
			} else if (criteria == "PaxY") {
				var val = !$scope.filterPaxY;
				initializeFilters();
				$scope.filterPaxY = val;
			} else if (criteria == "Adults") {
				var val = !$scope.filterAdults;
				initializeFilters();
				$scope.filterAdults = val;
			} else if (criteria == "Children") {
				var val = !$scope.filterChildren;
				initializeFilters();
				$scope.filterChildren = val;
			} else if (criteria == "Infants") {
				var val = !$scope.filterInfants;
				initializeFilters();
				$scope.filterInfants = val;
			} else if (criteria == "Fqtv-silver") {
				var val = !$scope.filterFqtvSilver;
				initializeFilters();
				$scope.filterFqtvSilver = val;
			} else if (criteria == "Fqtv-gold") {
				var val = !$scope.filterFqtvGold;
				initializeFilters();
				$scope.filterFqtvGold = val;
			} else if (criteria == "Connections") {
				var val = !$scope.filterConnections;
				$scope.showConnections = true;
				initializeFilters();
				$scope.filterConnections = val;
			} else if (criteria == "UMs") {
				var val = !$scope.filterUMs;
				initializeFilters();
				$scope.filterUMs = val;
			} else if (criteria == "SpecialMeals") {
				var val = !$scope.filterSpecialMeals;
				initializeFilters();
				$scope.showMeals = true;
				$scope.filterSpecialMeals = val;
			} else if (criteria == "Wheelchair") {
				var val = !$scope.filterWheelchair;
				initializeFilters();
				$scope.filterWheelchair = val;
			} else if (criteria == "Assistance") {
				var val = !$scope.filterAssistance;
				initializeFilters();
				$scope.filterAssistance = val;
			} else if (criteria == "Deportees") {
				var val = !$scope.filterDeportees;
				initializeFilters();
				$scope.filterDeportees = val;
			} else if (criteria == "DHC") {
				var val = !$scope.filterDHC;
				initializeFilters();
				$scope.filterDHC = val;
			} else if (criteria == "VIP") {
                var val = !$scope.filterVIP;
                initializeFilters();
                $scope.filterVIP = val;
			}
			
		}

		/**
		 * Toggle view from seatmap to paxlist
		 * @memberof PaxCtrl
		 */
		function toggleFlightInfoView(mode) {
			$scope.mode = mode;
		}

		/**
		 * Initialize View Mode
		 * @memberof PaxCtrl
		 */
		function initializeViewMode() {
			$scope.showPaxName = true;
			$scope.showDetails = true;
			$scope.showConnections = true;
			$scope.showMeals = false;
		}

		/**
		 * Set the desired view style
		 * @memberof PaxCtrl
		 * @param {string} mode The view mode
		 */
		function viewMode(mode) {
			if (mode == "PaxName") {
				$scope.showPaxName = !$scope.showPaxName;
			} else if (mode == "Details") {
				$scope.showDetails = !$scope.showDetails;
			} else if (mode == "Connections") {
				$scope.showConnections = !$scope.showConnections;
			} else if (mode == "Meals") {
				$scope.showMeals = !$scope.showMeals;
			}
		}

		/**
		 * Show only the  Rows that have a passenger that is valid with the current filters
		 * @memberof PaxCtrl
		 * @param {object} row The passenger row
		 */
		function filterRow(row) {
			var isValid = false;
			if ($scope.filterPaxC || $scope.filterPaxY || $scope.filterAdults || $scope.filterChildren
				|| $scope.filterInfants || $scope.filterUMs || $scope.filterFqtv || $scope.filterConnections 
				|| $scope.filterSpecialMeals || $scope.filterFqtvSilver || $scope.filterFqtvGold 
				|| $scope.filterWheelchair || $scope.filterAssistance || $scope.filterDeportees 
				|| $scope.filterDHC || $scope.filterVIP) {
				for (var i = 0; i < row.Columns.length; i++) {
					if (filterCol(row.Columns[i])) {
						isValid = true;
					}
				}
			} else {
				isValid = true;
			}
			return isValid;
		}

		/**
		 * Disable the  passenger seats that is not valid with the current filters
		 * @memberof PaxCtrl
		 * @param {object} col The passenger seat
		 */
		function filterCol(col) {
			var IsValid = true;

			if ($scope.filterPaxC && col.Cabin != "C") {
				IsValid = false;
			} else if ($scope.filterPaxY && col.Cabin != "Y") {
				IsValid = false;
			} else if ($scope.filterAdults && col.Type != 'A') {
				IsValid = false;
			} else if ($scope.filterChildren && col.Type != 'C') {
				IsValid = false;
			} else if ($scope.filterInfants && (col.Type != 'I' && !(col.Type == 'A' && col.InfantName))) {
				IsValid = false;
			} else if ($scope.filterFqtv && col.Fqtv == null) {
				IsValid = false;
			} else if ($scope.filterConnections && col.Connection == null) {
				IsValid = false;
			} else if ($scope.filterUMs && !(col.SSR != null && col.SSR.IsUMNR)) {
				IsValid = false;
			} else if ($scope.filterSpecialMeals && col.SpecialMeal == null && col.SpecialMealB == null) {
				IsValid = false;
			} else if ($scope.filterFqtvSilver && !(col.Fqtv != null && (col.Fqtv.TierLevel == 'BLUT' || col.Fqtv.TierLevel == 'SLVT'))) {
				IsValid = false;
			} else if ($scope.filterFqtvGold && !(col.Fqtv != null && col.Fqtv.TierLevel == 'GLDT')) {
				IsValid = false;
			} else if ($scope.filterWheelchair && !(col.SSR != null && col.SSR.IsGroupPRM)) {
				IsValid = false;
			} else if ($scope.filterAssistance && !(col.SSR != null && (col.SSR.IsDEAF || col.SSR.IsBLND || col.SSR.IsDPNA))) {
				IsValid = false;
			} else if ($scope.filterDeportees && !(col.SSR != null && (col.SSR.IsINAD || col.SSR.IsGroupDEP))) {
				IsValid = false;
			} else if ($scope.filterDHC && !col.IsDHC) {
				IsValid = false;
			} else if ($scope.filterVIP && !col.IsVIP) {
				IsValid = false;
			}


			return IsValid;
		}

		/**
		 * Initialize Passenger Filters and the desired view style
		 * @memberof PaxCtrl
		 */
		function resetFilters() {
			initializeFilters();
			initializeViewMode();
		}

		/**
		 * Open Passenger Modal View
		 * @memberof PaxCtrl
		 * @param {object} inputObject The passenger informations
		 * @param {string} arrival The flights Arrival
		 */
		function openPassenger(inputObject, arrival) {
			if (inputObject.IsEmptySeat == 0 && (inputObject.SeatMode == 'Seat' || inputObject.SeatMode == 'Jumpseat')) {
				$uibModal.open({
					templateUrl: 'views/Dialogs/dlgPassenger.html',
					controller: 'PassengerCtrl',
					size: 'md',
					backdrop: 'static',
					keyboard: false,
					resolve: {
						passenger: function () {
							return inputObject;
						},
						arrival: function () {
							return arrival;
						}
					}
				})
			}
		}


		/**
		 * Checks if the data are new
		 * @memberof PaxCtrl
		 * @param {string} time timestamp
		 * @return {boolean} IsOld
		 */
		function IsOld(time) {
			IsOld = false;
			if (time) {
				var now = new Date();
				var timeDate = new Date(time);
				var diff = now.getTime() - timeDate.getTime();
				if (diff > 3600000) {
					IsOld = true;
				}
			}
			return IsOld;
		}

		/**
		 * Calculates if a connecting flight is departs sort time after fligths arrival 
		 * @memberof PaxCtrl
		 * @param {string} connection Connection STD
		 * @return {string} cssClass
		 */
		function isConnectedFlightClose(connection) {
			if (!connection) {
				return '';
			}

			var connFlightDate = new Date(connection.STD).getTime();

			if ($scope.flightETA > connFlightDate)
				return '';

			if ((connFlightDate - $scope.flightETA) < connection.MCT * 60000) {
				return 'bg-bisque';
			}

			if ((connFlightDate - $scope.flightETA) < (connection.MCT + 15) * 60000) {
				return 'bg-cornsilk';
			}
			return '';
		}

		/**
		 * Returns the time difference
		 * @memberof PaxCtrl
		 * @param {string} time Connection STD
		 * @return {string} timeDifference
		 */
		function TimeDifference(time) {
			var timeString = '';
			var sign = '';
			var dayString = null;

			if (time) {
				var connFlightDate = new Date(time);
				var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
				if (ms < 0) {
					ms = -ms;
					sign = "-";
				}

				var days = Math.floor(ms / (24 * 60 * 60 * 1000));
				days = days < 0 ? days + 1 : days;
				var daysms = ms % (24 * 60 * 60 * 1000);
				var hours = Math.floor((daysms) / (60 * 60 * 1000));
				var hoursms = ms % (60 * 60 * 1000);
				var minutes = Math.floor((hoursms) / (60 * 1000));
				timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
				dayString = ' <span class="badge">' + days + 'd</span>';
			}
			return timeString + ((days && days != 0) ? dayString : '');
		}
	}

})();